
import Vue from 'vue';
import VideoPlayer from '@owc-packages/VideoPlayer/src/VideoPlayer.vue';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import { mountFootnotes } from '@owc-utils/Footnotes/FootnotesHelper';
import {
  MediaGalleryCarouselImage,
  MediaGalleryCarouselItem,
  MediaGalleryCarouselVideo,
  UnifiedFormat,
} from './MediaGalleryOverlay';
import { transformCarouselToUnifiedFormat, isCarouselItemAVideo } from './MediaGalleryOverlayUtils';
export default Vue.extend({
  name: 'owc-media-gallery-carousel-item',
  props: {
    item: {
      type: Object as () => MediaGalleryCarouselItem<MediaGalleryCarouselImage | MediaGalleryCarouselVideo>,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  async mounted() {
    this.$nextTick(() => {
      if (this.$el instanceof HTMLElement) {
        mountFootnotes(this);
      }
    });
  },
  components: { VideoPlayer, GenericImage },
  computed: {
    mediaGalleryCarouselItem(): UnifiedFormat {
      return transformCarouselToUnifiedFormat(this.item);
    },
    title(): string {
      return this.mediaGalleryCarouselItem.title;
    },
    description(): string | undefined {
      return this.mediaGalleryCarouselItem.description;
    },
    isVideo(): boolean {
      return isCarouselItemAVideo(this.item);
    },
  },
});
